<script>
import { Scatter } from 'vue-chartjs'

export default {
  extends: Scatter,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>


// WEBPACK FOOTER //
// ScatterChart.vue?25040940